import React from "react";

import { OrderDto } from "services/orders/restModels";
import { localizedText } from "shared/lib/localizedMap";
import { SectionCard } from "shared/ui";

import { useOrderDetailsContext } from "features/OrderDetails/context";

import {
    Amount,
    Comment,
    Discounted,
    Item,
    Line,
    List,
    ModifierLine,
    Name,
    Total,
} from "./styles";

export const OrderItemsList = ({ order }: { order: OrderDto }) => {
    const state = useOrderDetailsContext();

    return (
        <SectionCard title="Состав заказа">
            <List>
                {order.items.map((item, index) => (
                    <Item key={`${item.menuItemId}-${index}`}>
                        <Line>
                            <Name>
                                {localizedText(item.name, state.locale)} × {item.count}
                            </Name>
                            <Amount>
                                {/* Цена со скидкой показывается только когда она отличается:
                                    промокод меняет её у части позиций, и молча печатать одну
                                    из двух сумм значит скрыть, что скидка вообще была. */}
                                {item.priceAfterDiscount.price === item.price.price ? (
                                    state.formatPrice(item.price)
                                ) : (
                                    <>
                                        <Discounted>
                                            {state.formatPrice(item.priceAfterDiscount)}
                                        </Discounted>{" "}
                                        <s>{state.formatPrice(item.price)}</s>
                                    </>
                                )}
                            </Amount>
                        </Line>

                        {item.modifiers.map((modifier, modifierIndex) => (
                            <ModifierLine key={`${modifier.name[state.locale]}-${modifierIndex}`}>
                                <Name>
                                    {localizedText(modifier.name, state.locale)} × {modifier.count}
                                </Name>
                                <Amount>{state.formatPrice(modifier.price)}</Amount>
                            </ModifierLine>
                        ))}

                        {item.comment && <Comment>{item.comment}</Comment>}
                    </Item>
                ))}

                <Total>
                    <Name>Итого</Name>
                    <Amount>{state.formatPrice(order.totalPrice)}</Amount>
                </Total>
            </List>
        </SectionCard>
    );
};
